import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { environment } from "../../src/environments/environment";
import { Observable, tap } from "rxjs";

export interface LoginRequest {
    email: string;
    password: string;
}

export interface UserDTO {
    id: number | string;
    name?: string;
    first_name?: string | null;
    last_name?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    email: string;
}

export interface LoginResponse {
    token: string;
    user: UserDTO;
    tenant: TenantDTO;
}

export interface TenantDTO {
    domain: string;
}

@Injectable({
    providedIn: 'root'
})
export class LoginService {
    private http = inject(HttpClient);
    private base = environment.apiUrl;

    get token(): string | null {
        return localStorage.getItem('auth_token');
    }

    get tenantDomain(): string | null {
        return localStorage.getItem('tenant_domain');
    }

    get currentUser(): UserDTO | null {
        const userJson = localStorage.getItem('current_user');
        return userJson ? JSON.parse(userJson) : null;
    }

    login(payload: LoginRequest): Observable<LoginResponse> {
        return this.http.post<LoginResponse>(`${this.base}/token/login`, payload)
            .pipe(
                tap(res => {
                    localStorage.setItem('auth_token', res.token);
                    if (res.tenant?.domain) {
                        localStorage.setItem('tenant_domain', res.tenant.domain);
                    } else {
                        localStorage.removeItem('tenant_domain');
                    }
                    if (res.user) {
                        localStorage.setItem('current_user', JSON.stringify(res.user));
                    } else {
                        console.warn('No user data in login response!');
                    }
                })
            );
    }

    logout(): Observable<void> {
        return this.http.post<void>(`${this.base}/logout`, {})
            .pipe(
                tap({
                    next: () => { 
                        localStorage.removeItem('auth_token'); 
                        localStorage.removeItem('tenant_domain'); 
                        localStorage.removeItem('current_user');
                    },
                    error: () => { 
                        localStorage.removeItem('auth_token'); 
                        localStorage.removeItem('tenant_domain'); 
                        localStorage.removeItem('current_user');
                    }, // biztos ami biztos
                })
            );
    }

    isAuthenticated(): boolean {
        return !!this.token;
    }
}
